// extracted by mini-css-extract-plugin
export default {"contactinfo":"WriteToUs_contactinfo__ydJlZ","call":"WriteToUs_call__e+ZyC","phone":"WriteToUs_phone__6tefD"};